/* eslint-disable no-prototype-builtins */
import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import Cropper from 'react-easy-crop'

import { navbarHeight, footerHeight, dashboardNavbarHeight, positionChangeWidthSm, cropAspectRatiosArray } from '../../../helpers/variableDefaults'
import { saveAndCancelButtonsJSX, titleAndAdvisoryJSX } from '../../../helpers/commonJSX'
import { returnCroppedImage, updateCroppedAWSFileAtURL, returnSquareVideoThumbnail, uploadCroppedAWSFilesArray, urlToImageFile, fileToDataURL, getStartCropImageWidthsAndHeights, getCurrentImageWidthsAndHeights } from '../../../helpers/imageHandling'
import { advisoryTypography } from '../../../helpers/typographies'
import { standardButton } from '../../../helpers/buttons'
import { reloadView } from '../../../helpers/globalHelpers'
import { pinturaEditorDefaults, pinturaEditorJSX } from '../../../helpers/pinturaHelpers'
import { capitalizeFirstLetter } from '../../../helpers/globalHelpers'

import { seoPageTags, customAnalyticsEvent } from '../../../helpers/analytics'

// Crop Media Carousel Page
const CropUpdateMediaCarousel = ({ updatedMediaItemObj, setUpdatedMediaItemObj, mediaItem, setMediaItem, previousMediaItem, setPreviousMediaItem, resetLoadingAndErrors, width }) => {

  const isPintura = updatedMediaItemObj.mediaType === 'video'

  // Navigate
  const navigate = useNavigate()

  // Ref
  const editorRef = useRef(null)

  // const [carouselIndex, setCarouselIndex] = useState(0)
  const [aspectRatioIndex, setAspectRatioIndex] = useState(0)
  const [trimCropIndex, setTrimCropIndex] = useState(0)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)

  // Loading
  const [loadingNewMedia, setLoadingNewMedia] = useState(false)
  const [creatingCropOrTrim, setCreatingCropOrTrim] = useState(false)

  // Errors
  const [errorNewMedia, setErrorNewMedia] = useState(false)

  // Save Successful
  const [saveSuccessfulNewMedia, setSaveSuccessfulNewMedia] = useState(false)
    
      
  useEffect(() => {
    // console.log('videoThumbnail useEffect runs')

  }, [creatingCropOrTrim])

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    // console.log('cropped area percentages ->', croppedArea)
    // console.log('cropped area pixels ->', croppedAreaPixels)

    setUpdatedMediaItemObj({
      ...updatedMediaItemObj,
      [cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop']: {
        x: croppedAreaPixels.x,
        y: croppedAreaPixels.y,
        width: croppedAreaPixels.width,
        height: croppedAreaPixels.height,
      },
    })

  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    if (
      saveSuccessfulNewMedia
      // || !saveSuccessfulNewMedia
    ) { 
      reloadView()
    } else {
      resetLoadingAndErrors()
      setUpdatedMediaItemObj({})
    }

    window.scrollTo(0, 0)
  }

  const handlePinturaSavePressed = () => {
    console.log('handlePinturaSavePressed runs')
    if (!creatingCropOrTrim) {
      editorRef.current.editor.processImage()
      setCreatingCropOrTrim(true)
    }
  }

  const handleSavePressed = async (videoFile) => {
    // console.log('handleSavePressed runs')
    // console.log('x ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].x)
    // console.log('y ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].y)
    // console.log('width ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].width)
    // console.log('height ->', newMediaArray[carouselIndex][cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].height)

    resetLoadingAndErrors()

    if (isPintura && trimCropIndex === 0) {
      setCreatingCropOrTrim(true)
      // Set Media Item with Trimmed Data URL
      setUpdatedMediaItemObj({ ...updatedMediaItemObj, file: videoFile, dataURL: await fileToDataURL(videoFile) })
      setTrimCropIndex(1)
      setCreatingCropOrTrim(false)
    } else {
      // Get Cropped Image
      // console.log('cropAspectRatiosArray[aspectRatioIndex].text ->', cropAspectRatiosArray[aspectRatioIndex].text)
      setCreatingCropOrTrim(true)
      if (updatedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCropDataURL' : 'portraitCropDataURL'].length === 0) {
        const croppedDataURL = isPintura 
          ? 
          await fileToDataURL(videoFile)
          :
          await returnCroppedImage(
            updatedMediaItemObj.dataURL,
            updatedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].x,
            updatedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].y,
            updatedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].width,
            updatedMediaItemObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCrop' : 'portraitCrop'].height
          )
        // console.log('croppedDataURL ->', croppedDataURL)
        // const croppedImageWidthAndHeight = await getCurrentImageWidthsAndHeights(croppedDataURL)
        const newCroppedFile = isPintura 
          ? 
          videoFile
          :
          await urlToImageFile(croppedDataURL, `crop${mediaItem._id}-${cropAspectRatiosArray[aspectRatioIndex].text}`)
        
        const newMediaObj = { ...updatedMediaItemObj }
        if (
          isPintura
          && cropAspectRatiosArray[aspectRatioIndex].text === 'square'
        ) {
          const newSquareVideoThumbnailAndDurationObj = await returnSquareVideoThumbnail(newCroppedFile)
          const videoThumbnailFile = await urlToImageFile(newSquareVideoThumbnailAndDurationObj.squareImage, `video-thumbnail-0`)
          newMediaObj.duration = newSquareVideoThumbnailAndDurationObj.duration
          newMediaObj.videoThumbnailDataURL = newSquareVideoThumbnailAndDurationObj.squareImage
          newMediaObj.videoThumbnailFile = videoThumbnailFile
        }
        
        // Set Media Obj with Cropped Data URL
        newMediaObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCropDataURL' : 'portraitCropDataURL'] = croppedDataURL
        newMediaObj[cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'squareCropFile' : 'portraitCropFile'] = newCroppedFile

        setUpdatedMediaItemObj({ ...newMediaObj })


        if (aspectRatioIndex < cropAspectRatiosArray.length - 1) {
          setAspectRatioIndex(aspectRatioIndex + 1)

          setCrop({ x: 0, y: 0 })
          setZoom(1)
          setCreatingCropOrTrim(false)
        } else {
          // console.log('newMediaArray ->', newMediaArray)
          console.log('newMediaObj ->', newMediaObj)

          if (
            Object.keys(newMediaObj).length > 0
            && 'duration' in newMediaObj
            && 'squareCropDataURL' in newMediaObj
            && newMediaObj.squareCropDataURL.length > 0
            && 'squareCropFile' in newMediaObj
            && 'squareURLString' in newMediaObj
            && 'portraitCropDataURL' in newMediaObj
            && newMediaObj.portraitCropDataURL.length > 0
            && 'portraitCropFile' in newMediaObj
            && 'portraitURLString' in newMediaObj
            // && 'videoThumbnailURL' in newMediaObj
            && (!isPintura || 'videoThumbnailFile' in newMediaObj)
            && 'videoThumbnailURLString' in newMediaObj
            && 'file' in newMediaObj
            && 'mediaType' in newMediaObj
            && 'fileName' in newMediaObj
            && 'bucketType' in newMediaObj
            && 'userId' in newMediaObj
            && 'email' in newMediaObj
          ) {
            setLoadingNewMedia(true)
            setErrorNewMedia(false)
      
            // Upload data
            try {
              // console.log('update the media here')
              // Update Image Code Here
              const updatedMedia = await updateCroppedAWSFileAtURL(newMediaObj)
              // console.log('updatedMedia ->', updatedMedia)

              if (
                updatedMedia.updateSuccessful 
              ) {
                // console.log('newMediaObj.duration ->', newMediaObj.duration)
                // setMediaItem({ 
                //   ...mediaItem, 
                //   url: 'newSquareURL' in updatedMedia && updatedMedia.newSquareURL.length > 0 && updatedMedia.newSquareURL !== 'NA' && updatedMedia.newSquareURL !== previousMediaItem.url ? updatedMedia.newSquareURL : mediaItem.url, 
                //   portraitURL: 'newPortraitURL' in updatedMedia && updatedMedia.newPortraitURL.length > 0 && updatedMedia.newPortraitURL !== 'NA' && updatedMedia.newPortraitURL !== previousMediaItem.portraitURL ? updatedMedia.newPortraitURL : mediaItem.portraitURL,
                //   videoThumbnailURL: 'newVideoThumbnailURL' in updatedMedia && updatedMedia.newVideoThumbnailURL.length > 0 && updatedMedia.newVideoThumbnailURL !== 'NA' && updatedMedia.newVideoThumbnailURL !== previousMediaItem.newVideoThumbnailURL ? updatedMedia.newVideoThumbnailURL : 'NA',
                //   duration: newMediaObj.duration,
                //   type: newMediaObj.mediaType,
                // })
                // setPreviousMediaItem({ 
                //   ...previousMediaItem, 
                //   url: 'newSquareURL' in updatedMedia && updatedMedia.newSquareURL.length > 0 && updatedMedia.newSquareURL !== 'NA' && updatedMedia.newSquareURL !== previousMediaItem.url ? updatedMedia.newSquareURL : mediaItem.url, 
                //   portraitURL: 'newPortraitURL' in updatedMedia && updatedMedia.newPortraitURL.length > 0 && updatedMedia.newPortraitURL !== 'NA' && updatedMedia.newPortraitURL !== previousMediaItem.portraitURL ? updatedMedia.newPortraitURL : mediaItem.portraitURL, 
                //   videoThumbnailURL: 'newVideoThumbnailURL' in updatedMedia && updatedMedia.newVideoThumbnailURL.length > 0 && updatedMedia.newVideoThumbnailURL !== 'NA' && updatedMedia.newVideoThumbnailURL !== previousMediaItem.newVideoThumbnailURL ? updatedMedia.newVideoThumbnailURL : 'NA',
                //   duration: newMediaObj.duration,
                //   type: newMediaObj.mediaType,
                // })

                if (isPintura && trimCropIndex !== 0) {
                  setTrimCropIndex(0)
                }

                setSaveSuccessfulNewMedia(true)
                setErrorNewMedia(false)
                setLoadingNewMedia(false)
              } else {
                console.log('update media unsuccessful')
                if (isPintura && trimCropIndex !== 0) {
                  setTrimCropIndex(0)
                }
                setErrorNewMedia(true)
                setLoadingNewMedia(false)
              }

            } catch (error) {
              console.log('error ->', error)

              if (isPintura && trimCropIndex !== 0) {
                setTrimCropIndex(0)
              }
      
              setErrorNewMedia(true)
              setLoadingNewMedia(false)
            }
          } else {
            console.log('upload data inconsistent')
            setErrorNewMedia(true)
          }

          // setUpdatedMediaItemObj({})
        }
      }
    }
  }

  const cropChange = async (crop) => {
    // console.log('crop ->', crop)
    setCrop(crop)

  }

  const zoomChange = async (zoom) => {
    setZoom(zoom)
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {/* {seoPageTags(
        'CropUpdateMediaCarousel'
      )} */}

      {/* Body */}
      {(loadingNewMedia || errorNewMedia || saveSuccessfulNewMedia) ?
        <Box
          sx={{
            width: '100%',
            minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`,
            // minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight} - ${footerHeight})`,
            pb: 10,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {/* Loading */}
          {loadingNewMedia
            && !errorNewMedia
            && !saveSuccessfulNewMedia
            &&
            advisoryTypography(
              updatedMediaItemObj.mediaType === 'image' ? 
                `Uploading Media...
                This may take a minute`
                :
                `Uploading Media...
                Video uploads may take a minute or two`
              , 
              'center'
            )
          }

          {/* Save Successful */}
          {saveSuccessfulNewMedia &&
            <Typography
              sx={{
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              Update Successful
            </Typography>
          }

          {/* Error */}
          {errorNewMedia &&
            <Typography
              textAlign={'left'}
              sx={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'red',
                maxWidth: '350px',
              }}
            >
              There was an error uploading your media. Check your Internet connection, read the Media Guidelines, and try again.
            </Typography>
          }

          {!loadingNewMedia && (saveSuccessfulNewMedia || errorNewMedia) &&
            standardButton(
              `OK`,
              'button',
              'contained',
              loadingNewMedia,
              'primary',
              2,
              1,
              0,
              '120px',
              '45px',
              handleCancelPressed
            )

          }

        </Box>
        :
        !isPintura ?
          <Box 
            sx={{ 
              minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`, 
              width: '100vw', 
              display: 'flex', flexDirection: 'column', justifyContent: width <= positionChangeWidthSm ? 'flex-start' : 'flex-start', alignItems: 'center', 
            }}
          >
            <Box
              sx={{
                width: '100%',
                // backgroundColor: 'pink',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              {/* Title */}
              <Box
                sx={{
                  mb: 1,
                  width: '100%',
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    mt: 2,
                    // mb: 1,
                    fontSize: '18px',
                    fontWeight: 'bold',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? 'Square Crop' : 'Portrait Crop'}
                </Typography>
                <Typography
                  sx={{
                    fontStyle: 'italic',
                    color: 'blue',
                    fontSize: '16px',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? '*Hinge' : '*Bumble, Tinder'}
                </Typography>
              </Box>
              

              {/* {cropAspectRatiosArray.map((cropAspectRatio, cropAspectRatioIndex) => ( */}
              <Box
                // key={cropAspectRatioIndex}
                sx={{
                  // backgroundColor: 'orange',
                  my: 1,
                  width: '300px',
                  // maxWidth: '300px',
                  height: '300px',
                  // maxHeight: '300px',
                  border: 2,
                  borderColor: 'black',
                }}
              >
                <Box
                  sx={{
                    height: '100%',
                    position: 'relative',
                  }}
                >
                  <Cropper
                    image={updatedMediaItemObj.dataURL}
                    crop={crop}
                    zoom={zoom}
                    aspect={cropAspectRatiosArray[aspectRatioIndex].aspectRatio}
                    onCropChange={cropChange}
                    onCropComplete={onCropComplete}
                    onZoomChange={zoomChange}
                    // style={{
                    //   containerStyle: { backgroundColor: 'white' },
                    // }}
                    objectFit={'cover'}
                  />
                </Box>
              </Box>
              {/* ))} */}
            </Box>

            {/* Save and Cancel Buttons */}
            {saveAndCancelButtonsJSX(
              false,
              false,
              handleCancelPressed,
              handleSavePressed,
              1,
              5,
              1,
              'warning',
              aspectRatioIndex < cropAspectRatiosArray.length - 1 ? 'secondary' : 'primary'
            )}

          </Box>
          :
          <Box 
            sx={{ 
              minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`, 
              width: '100vw', 
              display: 'flex', flexDirection: 'column', justifyContent: width <= positionChangeWidthSm ? 'flex-start' : 'flex-start', alignItems: 'center', 
            }}
          >
            {/* Title */}
            <Box
              sx={{
                mb: 1,
                width: '100%',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  mt: 2,
                  fontSize: '18px',
                  fontWeight: 'bold',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {trimCropIndex === 0 && updatedMediaItemObj.mediaType === 'video' ? 'Video Trim' : `${capitalizeFirstLetter(cropAspectRatiosArray[aspectRatioIndex].text)} Crop`}
              </Typography>
              {trimCropIndex > 0 &&
                <Typography
                  sx={{
                    fontStyle: 'italic',
                    color: 'blue',
                    fontSize: '16px',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {cropAspectRatiosArray[aspectRatioIndex].text === 'square' ? '*Hinge' : '*Bumble, Tinder'}
                </Typography>
              }
            </Box>


            <Box
              sx={{
                height: '50vh',
                width: '100%',
              }}
            >
              {pinturaEditorJSX(
                editorRef, 
                updatedMediaItemObj.dataURL, 
                (updatedMediaItemObj.mediaType === 'video' && trimCropIndex === 0) ? undefined : cropAspectRatiosArray[aspectRatioIndex].aspectRatio, 
                updatedMediaItemObj.mediaType, 
                trimCropIndex, 
                handleSavePressed
              )}
            </Box>


            {/* Save and Cancel Buttons */}
            {saveAndCancelButtonsJSX(
              false,
              creatingCropOrTrim,
              handleCancelPressed,
              handlePinturaSavePressed,
              (updatedMediaItemObj.mediaType === 'video' && trimCropIndex === 0) ? 0 : -2,
              5,
              1,
              'warning',
              ((aspectRatioIndex < cropAspectRatiosArray.length - 1)) ? 'secondary' : 'primary'
            )}
          </Box>
      }
    </>
  )
}

export default CropUpdateMediaCarousel